module.exports = __webpack_public_path__ + "img/back_button.e3d269ae.svg";